(function($) {
	if(!$('body').hasClass('logged-in')) return;

	var $button = $('.category-subscribe-button');

	$button.click(function(e) {
		e.preventDefault();

		$.ajax({
			url: ajax_object.ajax_url,
			type: 'POST',
			data: {
				action: 'update_product_categories',
				termId: smart_category_subscriptions.termId
			},
			success: function(response) {
				if(response.success) {
					if(response.data.subscribed) {
						$button.addClass('subscribed').text('Avslutt abonnement');
					} else {
						$button.removeClass('subscribed').text('Abonner');
					}
				}
			},
			error: function(errorThrown) {
				console.log(errorThrown);
			}
		});
	})
	
	$.ajax({
		url: ajax_object.ajax_url,
		type: 'POST',
		data: {
			action: 'check_product_category',
			termId: smart_category_subscriptions.termId
		},
		success: function(response) {
			if(response.success) {
				if(response.data.subscribed) {
					$button.addClass('subscribed').text('Avslutt abonnement');
				} else {
					$button.removeClass('subscribed').text('Abonner');
				}
				setTimeout(() => {
					$button.fadeIn('slow');
				}, 1000);
			}
		},
		error: function(errorThrown) {
			console.log(errorThrown);
		}
	});
})(jQuery);